
import transList from "../database/transList.json"

export  function translator(original,lang,ref) {

    if (lang==="fr"){
        return original;
    }
    else{
        let trans = transList.find(tr=>tr.ref===ref);
        if (trans){ // to be sure that ref is correct
            return trans.eng
        }
            else{
                return original
        } 
    }
   
}